import Vue from 'vue';
import VueI18n, {IVueI18n} from "vue-i18n";
import messages from '@/locale';

Vue.use(VueI18n);

const i18n: IVueI18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'ru',
  fallbackLocale: 'ru',
  messages,
});

export default i18n;